import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(true);
  
  const { token } = useParams();
  const navigate = useNavigate();
  
  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    padding: '0 1rem'
  };
  
  const cardStyle = {
    maxWidth: '400px',
    width: '100%',
    padding: '2rem',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  };
  
  const headingStyle = {
    fontSize: '1.875rem',
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'center'
  };
  
  const logoStyle = {
    fontSize: '2.25rem',
    fontWeight: 'bold',
    color: '#ff6b00',
    textAlign: 'center',
    marginBottom: '0.5rem'
  };
  
  const formStyle = {
    marginTop: '1.5rem'
  };
  
  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    border: '1px solid #d1d5db',
    borderRadius: '0.375rem',
    marginBottom: '1rem'
  };
  
  const buttonStyle = {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#4f46e5',
    color: 'white',
    border: 'none',
    borderRadius: '0.375rem',
    fontWeight: '500',
    cursor: 'pointer'
  };
  
  const errorStyle = {
    color: '#dc2626',
    fontSize: '0.875rem',
    marginBottom: '1rem'
  };
  
  const linkStyle = {
    color: '#4f46e5',
    cursor: 'pointer',
    fontSize: '0.875rem'
  };
  
  useEffect(() => {
    // TODO: Add token validation API call if needed
    // This would check if the token is valid before showing the form
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validate passwords
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }
    
    if (password.length < 8) {
      return setError('Password must be at least 8 characters long');
    }
    
    setIsLoading(true);
    
    try {
      const response = await axios.post('/api/admin-auth/reset-password/confirm', {
        token,
        password
      });
      
      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.message || 'Password reset failed');
      }
    } catch (err) {
      console.error('Password reset error:', err);
      setError(err.response?.data?.message || 'Password reset failed. Please try again.');
      
      // If token is invalid or expired
      if (err.response?.status === 400) {
        setIsTokenValid(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isTokenValid) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={logoStyle}>CNXN</div>
          <h2 style={headingStyle}>Invalid Reset Link</h2>
          <div style={{ textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
            <p>This password reset link is invalid or has expired.</p>
            <p style={{ marginTop: '1rem' }}>
              <button
                onClick={() => navigate('/admin/login')}
                style={linkStyle}
              >
                Return to login
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={logoStyle}>CNXN</div>
          <h2 style={headingStyle}>Password Reset Complete</h2>
          <div style={{ textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
            <p>Your password has been successfully reset.</p>
            <p style={{ marginTop: '1rem' }}>
              <button
                onClick={() => navigate('/admin/login')}
                style={linkStyle}
              >
                Proceed to login
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={logoStyle}>CNXN</div>
        <h2 style={headingStyle}>Reset Your Password</h2>
        
        <form style={formStyle} onSubmit={handleSubmit}>
          <div>
            <input
              id="password"
              name="password"
              type="password"
              required
              style={inputStyle}
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              required
              style={inputStyle}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          {error && (
            <div style={errorStyle}>
              {error}
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={isLoading}
              style={buttonStyle}
            >
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminResetPassword;
